import OrderedMap from "orderedmap";
import { Schema } from "prosemirror-model";
import { suggest } from "prosemirror-suggest";
export class Extension {
    addNodes(nodes) {
        return nodes;
    }
    addMarks(marks) {
        return marks;
    }
    addPlugins(schema, plugins, _context) {
        return plugins;
    }
    addNodeViews(schema, nodeViews, portalContainer) {
        return nodeViews;
    }
    addSlashCommands(commands) {
        return commands;
    }
    initializeView(view) {
        return view;
    }
    addSuggesters(suggesters, _slashCommands) {
        return suggesters;
    }
    addCommands(_schema) {
        return {};
    }
}
export function generateNodes(extensions) {
    return extensions.reduce((acc, extension) => extension.addNodes(acc), OrderedMap.from({}));
}
export function generateMarks(extensions) {
    return extensions.reduce((acc, extension) => extension.addMarks(acc), OrderedMap.from({}));
}
export function generateNodeViews(schema, extensions, portalContainer) {
    return extensions.reduce((acc, extension) => extension.addNodeViews(schema, acc, portalContainer), {});
}
export function generateSchema(extensions) {
    const nodes = generateNodes(extensions);
    const marks = generateMarks(extensions);
    // for some reason, we're getting an error: "Schema is missing its top node type ('doc')"
    // when giving `nodes` directly to Schema constructor, so we need to convert back to an object
    // TODO: consider not using OrderedMap in the Extension `addNodes` method.
    const nodesDict = {};
    nodes.forEach((key, value) => (nodesDict[key] = value));
    const marksDict = {};
    marks.forEach((key, value) => (marksDict[key] = value));
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return new Schema({ nodes: nodesDict, marks: marksDict });
}
export function generateSuggestersPlugin(extensions) {
    const slashCommands = generateSlashCommandSpecs(extensions);
    const specs = extensions.reduce((acc, extension) => extension.addSuggesters(acc, slashCommands), []);
    return suggest(...specs);
}
export function generateSlashCommandSpecs(extensions) {
    return extensions.reduce((acc, extension) => extension.addSlashCommands(acc), []);
}
export function generatePlugins(schema, extensions, portalContainer) {
    const commands = generateCommands(schema, extensions);
    return [
        generateSuggestersPlugin(extensions),
        ...extensions.reduce((acc, extension) => extension.addPlugins(schema, acc, { commands, portalContainer }), []),
    ];
}
export function generateCommands(schema, extensions) {
    return extensions.reduce((commands, extension) => ({
        ...commands,
        ...extension.addCommands(schema),
    }), {});
}
export function initializeView(view, extensions) {
    extensions.forEach((extension) => extension.initializeView(view));
}
